import { render, staticRenderFns } from "./regresos_reporte.vue?vue&type=template&id=1b36ee8b&scoped=true&"
import script from "./regresos_reporte.vue?vue&type=script&lang=js&"
export * from "./regresos_reporte.vue?vue&type=script&lang=js&"
import style0 from "./regresos_reporte.vue?vue&type=style&index=0&id=1b36ee8b&scoped=true&lang=css&"
import style1 from "./regresos_reporte.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b36ee8b",
  null
  
)

export default component.exports